import { useRef } from 'react';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import MainLayout from '@/layout/MainLayout';
import pageProps from '@/layout/pageProps';
import ListNav from '@/components/pages/news/ListNav';
import useNoticeData from '@/utils/hooks/news/useNoticeData';
import { getNotice } from '@/utils/api/SSRRequest';
import moment from 'moment';

import styles from '@/styles/pages/news/announcement/index.module.scss';
import CenterLayout from '@/layout/centerLayout/CenterLayout';
import { NoData } from '@/components/common/Empty';

const ImageView = dynamic(() => import('@/components/pages/news/ImageView'), { ssr: false });

const sortTime = (a, b) => {
  if (a.top === true && b.top === false) return -1;
  if (a.top === false && b.top === true) return 1;
  if (a.time < b.time) return 1;
  return -1;
};

function Page({ apiData }) {
  const router = useRouter();
  const contentRef = useRef(null);
  const { id } = router.query;
  const { t, i18n } = useTranslation('pages', { keyPrefix: 'news.announcement' });
  const { data: hookData } = useNoticeData();
  const data = hookData || apiData;
  const detail = id ? data.find((item) => item.id === id) : data?.[0];

  return (
    <>
      <ImageView contentRef={contentRef} />
      <MainLayout
        headProps={{
          title: t('meta.title'),
          keyword: t('meta.keyword'),
          canonical: `https://www.bitop.com${i18n.language === 'en' ? '/en' : ''}news/announcement`,
        }}
        pageClassName={styles.pageContainer}
      >
        <CenterLayout detail={detail}>
          <main className={styles.container}>
            {id === undefined ? (
              <section className={styles.pageList}>
                {/* <div className={styles.title}>{t('header')}</div> */}
                <ListNav key={Date.now()} className={styles.listNav} defaultlist={apiData} tab="/announcement" listHook={useNoticeData} />
              </section>
            ) : (
              <section className={styles.contents}>
                <article>
                  {detail ? (
                    <>
                      <h2 className={styles.title}>{`【${t(`type.${detail.type}`)}】 ${detail.title}`}</h2>
                      <h5 className={styles.time}>
                        {
                          i18n.language === 'en' ? moment(detail.time).format('[Published on] MMM Do, YYYY')
                            : moment(detail.time).format('YYYY年MM月DD日[发布]')
                        }
                      </h5>
                      {/* eslint-disable-next-line react/no-danger */}
                      <div ref={contentRef} className={styles.detail} dangerouslySetInnerHTML={{ __html: detail.content }} />
                    </>
                  ) : (
                    <div className={styles.empty}>
                      <NoData />
                    </div>
                  )}
                </article>
              </section>
            )}
          </main>
        </CenterLayout>
      </MainLayout>
    </>
  );
}

Page.propTypes = {
  apiData: PropTypes.instanceOf(Object),
};
Page.defaultProps = {
  apiData: [],
};

export async function getServerSideProps(props) {
  const defaultProps = await pageProps(props);
  const { data } = await getNotice({ lang: props.locale, content: false });
  return { props: { ...defaultProps, apiData: (data || []).sort(sortTime) } };
}

export default Page;
